document.addEventListener("DOMContentLoaded", function () {
  const animOpacity = document.querySelectorAll(".animOpacity");
  const animStage = document.querySelectorAll(
    ".indoor-plant-section .animStage"
  );
  const animStageLeafsCard = document.querySelectorAll(
    ".leafs-cards-container .animStage"
  );
  const animStagePlantExpert = document.querySelectorAll(
    ".plant-expert-section .animStage"
  );
  const animStageArtificialPlant = document.querySelectorAll(
    ".artificial-plants-section .animStage"
  );

  function addAnimation() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    const stageObserver = new IntersectionObserver(
      (entries, stageObserver) => {
        let stageValue = entries[0].target.getAttribute("data-stage") ?? 80;

        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("show");
            }, index * stageValue);

            stageObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    const stageObserverMobile = new IntersectionObserver(
      (entries, stageObserver) => {
        let stageValue = entries[0].target.getAttribute("data-stage") ?? 80;

        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("show");
            }, index * stageValue);

            stageObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    animOpacity.forEach((element) => {
      observer.observe(element);
    });
    animStage.forEach((element) => {
      stageObserver.observe(element);
    });

    animStageLeafsCard.forEach((element) => {
      if (
        element.parentElement.scrollWidth > element.parentElement.clientWidth
      ) {
        stageObserverMobile.observe(element);
      } else {
        stageObserver.observe(element);
      }
    });

    animStagePlantExpert.forEach((element) => {
      stageObserver.observe(element);
    });
    animStageArtificialPlant.forEach((element) => {
      stageObserver.observe(element);
    });
  }

  document.addEventListener("load", addAnimation());
  document.addEventListener("scroll", addAnimation);
});
